import { Dropdown } from "semantic-ui-react";
import { NavLink } from "react-router-dom";

export function DropdownRenderer({ value, text, row }) {

  if (value) {
    const totalRowCount = row.api.getDisplayedRowCount(); // only visible rows
    const currentPage = row.api.paginationGetCurrentPage();
    const pageSize = row.api.paginationGetPageSize();
    const isLastPage = currentPage === Math.floor((totalRowCount - 1) / pageSize);

    const rowsOnPage = isLastPage
      ? totalRowCount % pageSize || pageSize // remainder rows or full page
      : pageSize;

    const indexInPage = row.node.rowIndex - currentPage * pageSize;
    // Only flip upward when there are actually enough rows on this page for a
    // downward menu to run off the bottom. With fewer than 5 rows the grid's
    // fixed-height container still has plenty of room below, and rowsOnPage - 5
    // would go negative, making every row (even the first) look "near the
    // bottom" and flip upward with nowhere to open into above it.
    const upward =
      pageSize === 5 ? false : rowsOnPage >= 5 && indexInPage > rowsOnPage - 5;

    return (
      <Dropdown
        style={{ background: "#0089a8", color: "white" }}
        button
        upward={upward}
        floating
        direction="left"
        text={text}
      >
        <Dropdown.Menu>
          {value.map((item, i) => (
            <Dropdown.Item
              key={i}
              style={{ zIndex: 2000 }}
              onClick={item.onClick}
            >
              {item.text}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

export function LinkRenderer(params) {
  return <NavLink to={params.value}>{params.text}</NavLink>;
}


export function CopyOnClickCellRenderer(params) {
  const handleClick = () => {
    if (params.value != null) {
      navigator.clipboard.writeText(params.value);
    }
  };

  return (
    <span onClick={handleClick} style={{ cursor: "pointer", userSelect: "text" }}>
      {params.value}
    </span>
  );
};



export function ListRenderer(params) {
  const list = params.value.map((item) => {
    return <li key={item.key}>{item.value}</li>;
  });

  return <ul className="exams-list">{list}</ul>;
}

export function CheckMarkRenderer(params) {
  if (params.value) {
    return (
      <i
        style={{ color: "#5cb84b", fontSize: "26px" }}
        className="check icon"
      ></i>
    );
  } else {
    return (
      <i
        style={{ color: "#db4737", fontSize: "26px" }}
        className="close icon"
      ></i>
    );
  }
}

export function ColorTextRenderer(params) {
  return <span style={{ color: params.color }}>{params.value}</span>;
}
